var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect } from 'react';
import PersonaReact from 'persona-react';
import { Callout, Container, Flex, Loader } from '@homeexchange/design';
import { runVerification } from '../../../api/KYC';
import i18n from '../../../i18n';
import Utils from '../../../utils/utils';
var Persona = function (_a) {
    var _b, _c;
    var status = _a.status, homeToVerify = _a.homeToVerify, onComplete = _a.onComplete;
    var _d = React.useState({
        inquiryId: null,
        sessionToken: null,
        message: null,
        loading: false,
        hasError: false
    }), kyc = _d[0], setKyc = _d[1];
    var hasRequested = React.useRef(false);
    var showFlow = function () {
        return Boolean(kyc.inquiryId || kyc.sessionToken);
    };
    useEffect(function () {
        if (hasRequested.current) {
            return;
        }
        var identity = status.identity, poa = status.poa;
        var sortedHomes = __spreadArray([], ((poa === null || poa === void 0 ? void 0 : poa.homes) || []), true).sort(function (a, b) { return (a.home_id <= b.home_id ? -1 : 1); });
        var eligibleHome = sortedHomes.find(function (home) { return !home.is_verified && home.verification_eligible; }) || null;
        var needVerification = !(identity === null || identity === void 0 ? void 0 : identity.is_verified) || sortedHomes.some(function (home) { return !home.is_verified; });
        var needVerificationForHome = eligibleHome !== null;
        var needVerificationForIdentity = !(identity === null || identity === void 0 ? void 0 : identity.is_verified) && needVerificationForHome;
        var verificationType;
        var homeId;
        var runPersonaCheck = function (config) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, inquiryId_1, sessionToken_1, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        setKyc(function (prev) { return (__assign(__assign({}, prev), { loading: true })); });
                        return [4 /*yield*/, runVerification(config)];
                    case 1:
                        _a = _b.sent(), inquiryId_1 = _a.inquiryId, sessionToken_1 = _a.sessionToken;
                        setKyc(function (prev) { return (__assign(__assign({}, prev), { inquiryId: inquiryId_1, sessionToken: sessionToken_1 !== null && sessionToken_1 !== void 0 ? sessionToken_1 : null, loading: false })); });
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        setKyc(function (prev) { return (__assign(__assign({}, prev), { hasError: true, loading: false })); });
                        console.error(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (needVerification && needVerificationForIdentity) {
            verificationType = 'identity';
            homeId = homeToVerify || (eligibleHome === null || eligibleHome === void 0 ? void 0 : eligibleHome.home_id);
        }
        else if (needVerification && needVerificationForHome) {
            verificationType = 'poa';
            homeId = eligibleHome === null || eligibleHome === void 0 ? void 0 : eligibleHome.home_id;
        }
        else {
            return;
        }
        if (homeId === undefined) {
            return;
        }
        hasRequested.current = true;
        runPersonaCheck({ userId: identity.user_id, homeId: homeId, verificationType: verificationType });
    }, [status, homeToVerify]);
    if (kyc.hasError) {
        return (React.createElement(Flex, { isFullHeight: true, alignItems: "center", justifyContent: "center" },
            React.createElement(Callout, { hasIcon: true, status: "error" }, i18n.t('user:page.verifPage.error.snackbar'))));
    }
    if (kyc.loading) {
        return (React.createElement(Flex, { style: { height: 'calc(100vh - 80px)' }, isFullHeight: true, alignItems: "center", justifyContent: "center" },
            React.createElement(Loader, { size: "large" })));
    }
    if (!showFlow()) {
        return null;
    }
    return (React.createElement(Container, { className: "kyc-iframe-container" },
        React.createElement(PersonaReact, { language: Utils.getWebsiteLanguage(), inquiryId: (_b = kyc.inquiryId) !== null && _b !== void 0 ? _b : undefined, sessionToken: (_c = kyc.sessionToken) !== null && _c !== void 0 ? _c : undefined, onComplete: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    setKyc(__assign(__assign({}, kyc), { message: 'Identity verification completed' }));
                    onComplete();
                    return [2 /*return*/];
                });
            }); }, onCancel: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    setKyc(__assign(__assign({}, kyc), { message: 'Identity verification cancelled', loading: false }));
                    return [2 /*return*/];
                });
            }); }, onError: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    setKyc(__assign(__assign({}, kyc), { message: 'Identity verification error', hasError: true, loading: false }));
                    return [2 /*return*/];
                });
            }); } })));
};
export default Persona;
